/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Form, Button, Row, Col } from 'reactstrap'
import { API } from "../../../config/api";
import { FaEdit, FaTimes } from 'react-icons/fa'
import Modal from 'react-bootstrap/Modal';
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import Swal from "sweetalert2";
import swal from "sweetalert";
import LoaderHome from "../../Loader/LoaderHome"
import axios from "axios";
import { Badge, Card, ListGroup } from "react-bootstrap";
import ModalContentReusable from "../../Global/ModalContent";

export default function ModalDetailDoctorSatuSehat(props) {
    const [getCodeRegion, setGetCodeRegion] = useState(null);
    const [getProvince, setGetDataProvince] = useState(null);
    const [getCity, setGetDataCity] = useState(null);
    const [getRegency, setGetDataRegency] = useState(null);
    const [getDistrict, setGetDataDistrict] = useState(null);
    const [getGender, setGetGender] = useState(null);
    const [getBirthDate, setGetBirthDate] = useState(null);
    const [getHisNumber, setGetHisNumber] = useState(null);
    const [getNikNumber, setGetNikNumber] = useState(null);
    const [getDetailDoctorByNIK, setGetDetailDoctorByNIK] = useState(null);
    const [getQualification, setGetQualification] = useState([]);
    const [getVerified, setGetVerified] = useState([]);

    let fetchParams = {
        headers: { "Authorization": `${props?.token}`, "Content-Type": "application/json" }
    };

    const GenerateTokenSatuSehat = async () => {
        props?.setLoading(true);
        try {
            const token = localStorage.getItem('token');

            const response = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/generate-token`, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Authorization": `${token}`,
                }
            });

            if (response?.status === 200) {
                props?.setGetDataTokenSatuSehat(response.data);
            }
        } catch (error) {
            Swal.fire({
                title: 'Failed',
                text: `${error.response.data.message}`,
                icon: 'error',
                timer: 3000,
                showConfirmButton: false
            });
        } finally {
            props?.setLoading(false);
        }
    };


    const GenerateNIKDoctorSatuSehat = async () => {
        props?.setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/doctor-nik`, {
                params: {
                    nik_doctor: `${getDetailDoctorByNIK?.user_detail?.unique_id}`
                },
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Authorization": `${token}`,
                }
            });

            if (response?.status === 200 || response?.status === 201) {
                const extensions = response?.data?.data?.entry?.[0]?.resource?.address?.[0]?.extension?.[0]?.extension;
                const gender = response?.data?.data?.entry?.[0]?.resource?.gender;
                const birthDate = response?.data?.data?.entry?.[0]?.resource?.birthDate;
                const hisNumber = response?.data?.data?.entry?.[0]?.resource?.identifier?.[0].value;
                const nikNumber = response?.data?.data?.entry?.[0]?.resource?.identifier?.[1].value;
                const qualification = response?.data?.data?.entry?.[0]?.resource?.qualification || [];
                const verified = response?.data?.data?.entry?.length > 0
                const getValue = (key) => {
                    return extensions?.find(item => item.url === key)?.valueCode || null;
                };

                const addressCodes = {
                    province: getValue('province'),
                    city: getValue('city'),
                    district: getValue('district'),
                    village: getValue('village'),
                    rw: getValue('rw'),
                    rt: getValue('rt'),
                };

                setGetGender(gender);
                setGetBirthDate(birthDate);
                setGetHisNumber(hisNumber);
                setGetNikNumber(nikNumber);
                setGetCodeRegion(addressCodes);
                setGetQualification(qualification);
                setGetVerified(verified);
            }
        } catch (error) {
            Swal.fire({
                title: 'Failed',
                text: `NIK Dokter tidak ada`,
                icon: 'error',
                timer: 3000,
                showConfirmButton: false
            });
        } finally {
            props?.setLoading(false);
        }
    };

    const GetResponseProvince = async () => {
        props?.setLoading(true);
        try {
            if (getCodeRegion?.province !== undefined) {
                const codeProvince = getCodeRegion?.province
                const response = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/provinces`, fetchParams);

                const findProvince = response.data.data.data.find((item) => item.code === codeProvince);
                if (findProvince) {
                    setGetDataProvince(findProvince.name);
                } else {
                    Swal.fire({
                        title: "Failed",
                        text: `Data dengan Bps Code 3172 tidak ditemukan`,
                        timer: 3000,
                        showConfirmButton: false,
                    });
                }
                return response;
            }
        } catch (error) {
            return { status: 500 };
        } finally {
            props?.setLoading(false);
        }
    };

    const GetResponseCity = async () => {
        props?.setLoading(true);

        try {
            if (getCodeRegion?.province !== undefined) {
                const response = await axios.get('https://api-ts.signatureanugerah.co.id/api/satu-sehat/cities', {
                    params: { province_id: getCodeRegion?.province },
                    headers: {
                        Authorization: `${props?.token}`,
                        "Content-Type": "application/json"
                    }
                });
                const filteredCity = response.data.data.data.find(item => item.bps_code === getCodeRegion?.city);
                if (filteredCity) {
                    setGetDataCity(filteredCity.name);
                } else {
                    Swal.fire({
                        title: "Failed",
                        text: `Data dengan Bps Code ${getCodeRegion?.city} tidak ditemukan`,
                        timer: 3000,
                        showConfirmButton: false,
                    });
                }
                return response;
            }

        } catch (error) {
            return { status: 500 };
        } finally {
            props?.setLoading(false);
        }
    };

    const GetResponseRegency = async () => {
        props?.setLoading(true);
        try {
            if (getCodeRegion?.city !== undefined) {
                const codeCity = getCodeRegion?.city
                const codeRegency = getCodeRegion?.district;

                const response = await axios.get('https://api-ts.signatureanugerah.co.id/api/satu-sehat/regencies', {
                    params: { city_id: codeCity },
                    headers: {
                        Authorization: `${props?.token}`,
                        "Content-Type": "application/json"
                    }
                });

                const filteredRegency = response.data.data.data.find(item => item.code === codeRegency);
                if (filteredRegency) {
                    setGetDataRegency(filteredRegency.name);
                } else {
                    Swal.fire({
                        title: "Failed",
                        text: `Data dengan Bps Code ${codeRegency} tidak ditemukan`,
                        timer: 3000,
                        showConfirmButton: false,
                    });
                }
                return response;
            }

        } catch (error) {
            return { status: 500 };
        } finally {
            props?.setLoading(false);
        }
    };

    const GetResponseDistrict = async () => {
        props?.setLoading(true);
        try {
            if (getCodeRegion?.district !== undefined) {
                const codeRegency = getCodeRegion?.district;
                const codeDistrict = getCodeRegion?.village
                const response = await axios.get('https://api-ts.signatureanugerah.co.id/api/satu-sehat/districts', {
                    params: { regency_id: codeRegency },
                    headers: {
                        Authorization: `${props?.token}`,
                        "Content-Type": "application/json"
                    }
                });

                const filteredDistrict = response.data.data.data.find(item => item.code === codeDistrict);
                if (filteredDistrict) {
                    setGetDataDistrict(filteredDistrict.name);
                } else {
                    Swal.fire({
                        title: "Failed",
                        text: `Data dengan Bps Code value tidak ditemukan`,
                        timer: 3000,
                        showConfirmButton: false,
                    });
                }
                return response;
            }
        } catch (error) {
            return { status: 500 };
        } finally {
            props?.setLoading(false);
        }
    };

    const GetResponseDetailDoctor = async () => {
        props?.setLoading(true);
        try {
            // e.preventDefault();
            const response = await API.get(`user-service/doctor-users/${props?.nikDoctorSatuSehat}`, fetchParams)
            // Checking process
            if (response?.status === 200) {
                setGetDetailDoctorByNIK(response?.data?.data)
            }
        } catch (error) {
            swal({
                title: 'Failed',
                text: `${error.response.data.message}`,
                icon: 'error',
                timer: 3000,
                buttons: false
            });
        } finally {
            props?.setLoading(false);
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            if (props?.getDataTokenSatuSehat.length === 0 && props?.nikDoctorSatuSehat) {
                await GenerateTokenSatuSehat();
            }

            if (props?.nikDoctorSatuSehat) {
                await GetResponseDetailDoctor();
            }
        };

        fetchData();
    }, [props?.getDataTokenSatuSehat, props?.nikDoctorSatuSehat]);

    useEffect(() => {
        if (getDetailDoctorByNIK?.user_detail?.unique_id) {
            GenerateNIKDoctorSatuSehat();
        }
    }, [getDetailDoctorByNIK?.user_detail?.unique_id]);

    useEffect(() => {
        const fetchAllWilayah = async () => {
            if (
                getCodeRegion?.province &&
                getCodeRegion?.city &&
                getCodeRegion?.district &&
                getCodeRegion?.village
            ) {
                props?.setLoading(true);
                const [res1, res2, res3, res4] = await Promise.all([
                    GetResponseProvince(),
                    GetResponseCity(),
                    GetResponseRegency(),
                    GetResponseDistrict(),
                ]);

                const allSuccess = [res1, res2, res3, res4].every(
                    (res) => res?.status === 200 || res?.status === 201
                );

                if (!allSuccess) {
                    Swal.fire({
                        title: 'Failed',
                        text: 'Ada kesalahan dalam memuat data wilayah.',
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                    });
                }

                props?.setLoading(false);
            }
        };

        fetchAllWilayah();
    }, [getCodeRegion]);


    return (
        <ModalContentReusable
            isOpen={props.show}
            isClose={props.onHide}
            size="lg"
            title="Dokter Satu Sehat"
        >
            <Row className="g-4 p-3">
                <Col md={6}>
                    <Card className="shadow-sm text-center">
                        <Card.Body>
                            <img
                                src={
                                    "https://storageapps.signatureanugerah.co.id/public/images/no-profile.png"
                                }
                                alt="Foto Pasien"
                                style={{ borderRadius: "50%", border: "2px solid #C9C9C9", marginBottom: "10px" }}
                            />
                            <h5>{getDetailDoctorByNIK?.user_detail?.firstname} {getDetailDoctorByNIK?.user_detail?.lastname}</h5>
                            {/* <Badge bg={data.smsAlert ? "success" : "danger"}>
                                {data.smsAlert ? "Aktif" : "Tidak Aktif"}
                            </Badge> */}
                            {/* <div className="mt-3">
                                <Button variant="warning">Simpan</Button>
                            </div> */}
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={6}>
                    {getNikNumber && getVerified ? (
                        <>
                            <Card className="shadow-sm">
                                <Card.Body>
                                    {/* <h6 className="fw-bold">Akun IHS</h6> */}
                                    <p>
                                        <strong>Nomor IHS:</strong> {getHisNumber} <br />
                                        <strong>NIK:</strong> {getNikNumber}
                                    </p>
                                    {/* <Button variant="danger" size="sm">Block Akun</Button> */}
                                    <hr />
                                    <h6 className="fw-bold">Kualifikasi</h6>
                                    {/* {getQualification.map((q, i) => (
                                        <div key={i}>
                                            {q.code.coding.map((c, j) => (
                                                <p key={j}>
                                                    ✅ {c.display}
                                                </p>
                                            ))}
                                        </div>
                                    ))} */}
                                    {getQualification[0]?.code?.coding.map((c, j) => (
                                        <p key={j}>
                                            ✅ {c.display}
                                        </p>
                                    ))}
                                </Card.Body>
                            </Card>
                            <Card className="shadow-sm mt-4">
                                <Card.Body>
                                    <h6 className="fw-bold">Alamat</h6>
                                    <ul className="list-unstyled">
                                        <li><strong>Provinsi:</strong> {getProvince}</li>
                                        <li><strong>Kab/Kota:</strong> {getCity}</li>
                                        <li><strong>Kecamatan:</strong> {getRegency}</li>
                                        <li><strong>Desa:</strong> {getDistrict}</li>
                                    </ul>

                                    <hr />
                                    <h6 className="fw-bold">Status Verifikasi</h6>
                                    <Badge bg="success">Terverifikasi</Badge>
                                </Card.Body>
                            </Card>
                        </>
                    ) : (
                        <>
                            <Card className="shadow-sm mt-4">
                                <Card.Body>
                                    <h6 className="fw-bold">Status Verifikasi</h6>
                                    <Badge bg="danger">Belum Terverifikasi</Badge>
                                </Card.Body>
                            </Card>
                        </>
                    )}
                </Col>
            </Row>


        </ModalContentReusable >
    );
}


